import { yupResolver } from "@hookform/resolvers";
import Checkbox from "@material-ui/core/Checkbox";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormGroup from "@material-ui/core/FormGroup";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { AddBox, Backup, CheckCircleOutline } from "@material-ui/icons";
import React, { useState } from "react";
import {useDispatch } from "react-redux";
import "./CreateOrderLayout.scss";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { CustomButton } from "../../components/@CustomComponents";
import FullPageLoader from "../../components/FullPageLoader/FullPageLoader";
import { API } from "../../modules/Api";
import Logger from "../../modules/Logger";
import S3Upload from "../../modules/S3Upload";
import { problemsToFixMock } from "../../needableData/problemsToFix";
import SuccessDialog from "./SuccessDialog";
import { setInfoPopup } from "../../redux/actions/infoPopupActions";


const orderStatus = [
  { id: 1, value: "INITIAL", label: "Первинний" },
  { id: 2, value: "SECONDARY", label: "Уточнюючий" },
  { id: 3, value: "THERAPY_CONTINUATION", label: "Продовження лікування"},
  { id: 4, value: "SPARE_ALIGNER", label: "Додатковий елайнер"},
  { id: 5, value: "RETAINER", label: "Ретейнер"}
];
const orderType = [
  { id: 1, value: "MAKE_ALIGNERS", label: "Готові елайнери" },
  { id: 2, value: "MODELS_3D", label: "3D моделі" },
];
const jawProjectMaterialType = [
  { id: 1, value: "IMPRINT", label: "Силіконові відбитки" },
  { id: 2, value: "SCAN_IMAGE", label: "3D Скани щелеп" },
];
  const newOrderStatus = "INITIAL";


  const CreateOrderLayout = () => {
  
  const [images, setImages] = useState([]);
  const [loadingOtherImages, setLoadingOtherImages] = useState(false);
  const [problemsToFix, setProblemsToFix] = useState(problemsToFixMock);
  const [loading, setLoading] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [files, setFiles] = useState(null);
  const dispatch = useDispatch();

  const [upperJaw, setUpperJaw] = useState({
    title: "Завантажити верхню щелепу",
    titleUploaded: "Верхню щелепу завантажено",
    fileType: "UPPER_JAW",
    uploading: false,
    uploaded: false,
  });
  const [lowerJaw, setLowerJaw] = useState({
    title: "Завантажити нижню щелепу",
    titleUploaded: "Нижня щелепа завантажена",
    fileType: "LOWER_JAW",
    uploading: false,
    uploaded: false,
  });
  const [bothJaws, setBothJaws] = useState({
    title: "Завантажити прикус",
    titleUploaded: "Прикус завантажений",
    fileType: "BOTH_JAWS",
    uploading: false,
    uploaded: false,
  });

  const formSchema = yup.object().shape({
    doctor: yup.string().required(),
    patient: yup.string().required(),
    city: yup.string().required(),
    country: yup.string().required(),
    order_status: yup.string().required(),
    order_type: yup.string().when('order_status', {
      "is": (value) => newOrderStatus === value,
      "then": yup.string().required()}
      ),
    jaw_project_material_type: yup.string().required(),
  });

  const { register, handleSubmit, errors, watch } = useForm({
    mode: "onChange",
    resolver: yupResolver(formSchema),
  });


  const newOrder = newOrderStatus === watch("order_status");
  const spareAligner = watch("order_status") === "SPARE_ALIGNER";
  const retainer = watch("order_status") === "RETAINER";
  const secondary = watch("order_status") === "SECONDARY";
  const therapy_continuation = watch("order_status") === "THERAPY_CONTINUATION";


  const problemsToFixHandler = (id) => {
    setProblemsToFix((prevState) => prevState.map((el) => (el.id === id ? { ...el, checked: !el.checked } : el)));
  };

  const createOrder = (data, e) => {
    const problems = {};
    // Do not send problems if user selected problems and then changed orderStatus (without problems)
    if (newOrderStatus === data.order_status){
      let intermediateObj = problemsToFix.map((el) => {
        if (el.checked) {
          return { [el.value]: true };
        }
        return true;
      });
      Object.assign(problems, ...intermediateObj);
    }
    setLoading(true);
    let order = {
      doctor: data.doctor,
      patient: data.patient,
      city: data.city,
      country: data.country,
      phone: data.phone,
      email: data.email,
      order_type: data.order_status,
      aligners_type: data.order_type,
      problems_to_fix: problems,
      order_files: files,
      doctors_comment: data.doctors_comment,
      jaw_project_material_type: data.jaw_project_material_type,
      send_from: "TRANSPADENT",
    };

    API.post("order", order)
      .then(() => {
        setDialog(true);
        setFiles(null);
        setImages([]);
        setProblemsToFix(problemsToFixMock);
        e.target.reset();
      })
      .catch((error) => {
        Logger.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const uploadOtherImages = (e) => {
    setLoadingOtherImages(true);

    let counter = 0;

    for (let i = 0; i < e.target.files.length; i++) {
      const currentFile = e.currentTarget.files[i];
      const imageId = `${Math.random()}${(+new Date()).toString(16)}`;
      let reader = new FileReader();
      reader.onload = function (e) {
        setImages((prev) => [...prev, { id: imageId, image: e.target.result }]);
      };
      e.persist();
      reader.readAsDataURL(e.target.files[i]);

      // eslint-disable-next-line no-loop-func
      S3Upload(currentFile, "OTHER").then((file) => {
        counter++;
        setFiles((prevState) => (prevState ? [...prevState, file] : [file]));

        if (counter === e.target.files.length) {
          setLoadingOtherImages(false);
        }
      }).catch((err)=>{
        console.log(err)
        counter++;
        // setFiles((prevState) => (prevState.filter((el) => {console.log("e", el); return el} ))); TODO: remove from storage
        if (counter === e.target.files.length) {
          setLoadingOtherImages(false);
        }
        dispatch(setInfoPopup("Ошибка сети или слишком большой файл!"));
      });
    }
  };

  const uploadStl = (e, fileType) => {
    switch (fileType) {
      case "UPPER_JAW":
        setUpperJaw((prevState) => ({ ...prevState, uploading: true }));
        break;
      case "LOWER_JAW":
        setLowerJaw((prevState) => ({ ...prevState, uploading: true }));
        break;
      case "BOTH_JAWS":
        setBothJaws((prevState) => ({ ...prevState, uploading: true }));
        break;
      default:
        return;
    }
    const currentFile = e.currentTarget.files[0];
    S3Upload(currentFile, fileType).then((file) => {
      switch (fileType) {
        case "UPPER_JAW":
          setUpperJaw((prevState) => ({ ...prevState, uploading: false, uploaded: true }));
          break;
        case "LOWER_JAW":
          setLowerJaw((prevState) => ({ ...prevState, uploading: false, uploaded: true }));
          break;
        case "BOTH_JAWS":
          setBothJaws((prevState) => ({ ...prevState, uploading: false, uploaded: true }));
          break;
        default:
          return;
      }
      setFiles((prevState) => (prevState ? [...prevState, file] : [file]));
      
    }).catch((error)=>{
      switch (fileType) {
        case "UPPER_JAW":
          setUpperJaw((prevState) => ({ ...prevState, uploading: false, uploaded: false }));
          break;
        case "LOWER_JAW":
          setLowerJaw((prevState) => ({ ...prevState, uploading: false, uploaded: false }));
          break;
        case "BOTH_JAWS":
          setBothJaws((prevState) => ({ ...prevState, uploading: false, uploaded: false }));
          break;
        default:
          return;
      }
      // setFiles((prevState) => (prevState ? [...prevState, file] : []));
      dispatch(setInfoPopup("Ошибка сети или слишком большой файл!"));
    })
  };

  return (
    <div className="createOrderLayout">
      {dialog && <SuccessDialog dialog={dialog} setDialog={setDialog} />}
      {loading && <FullPageLoader withOverlay />}
      <div className="createOrderLayout__box">
        <div className="createOrderLayout__title">
          <div className="createOrderLayout__logo">
            <img src={require("../../assets/img/login_transpadent.png")} alt="" />
          </div>
          <h2 className="createOrderLayout__text">Створення замовлення планування системи елайнерів</h2>
        </div>
        <form className="createOrderLayout__form" noValidate onSubmit={handleSubmit(createOrder)}>
          <div className={`createOrderLayout__input ${errors.doctor ? "error" : ""}`}>
            <div className="createOrderLayout__name">Лікар:</div>
            <input name={"doctor"} ref={register} />
          </div>
          <div className={`createOrderLayout__input ${errors.patient ? "error" : ""}`}>
            <div className="createOrderLayout__name">Пацієнт:</div>
            <input name={"patient"} ref={register} />
          </div>
          <div className={`createOrderLayout__input ${errors.city ? "error" : ""}`}>
            <div className="createOrderLayout__name">Місто:</div>
            <input name={"city"} ref={register} />
          </div>
          <div className={`createOrderLayout__input ${errors.country ? "error" : ""}`}>
            <div className="createOrderLayout__name">Країна:</div>
            <input name={"country"} ref={register} />
          </div>
          <div className={`createOrderLayout__input withNotification ${errors.phone ? "error" : ""}`}>
            <div className="createOrderLayout__name">Телефон:</div>
            <input type={"tel"} name={"phone"} ref={register} />
            <p>Обов'язково, якщо раніше не було замовлень у компанії TranspaDent</p>
          </div>

          <div className={`createOrderLayout__input withNotification ${errors.email ? "error" : ""}`}>
            <div className="createOrderLayout__name">Эл.почта:</div>
            <input type={"email"} name={"email"} ref={register} />
            <p>Обов'язково, якщо раніше не було замовлень у компанії TranspaDent</p>
          </div>

          <div className="createOrderLayout__radioBox">
            <div className={`createOrderLayout__name ${errors.order_status ? "error" : ""}`}>Статус замовлення:</div>
            <RadioGroup row name="order_status" style={{ justifyContent: "space-evenly" }}>
              {orderStatus.map(({ id, value, label }) => (
                <FormControlLabel
                  key={id}
                  inputRef={register}
                  labelPlacement="start"
                  value={value}
                  control={<Radio />}
                  label={label}
                />
              ))}
            </RadioGroup>
          </div>
          
          { secondary &&  <div className="createOrderLayout__instructions">Вкажіть, будь ласка, в коментарях що саме Ви б хотіли виправити для досягнення заявленого результату!</div>}
          { therapy_continuation &&  <div className="createOrderLayout__instructions">Вкажіть, будь ласка, в коментарях від якого за номером елайнера потрібно виготовити для продовження лікування!</div>}
          { spareAligner && <div className="createOrderLayout__instructions">Вкажіть який саме за номером елайнер потрібно виготовити і на яку щелепу в коментарях!</div>}
          { retainer && <div className="createOrderLayout__instructions">Вкажіть на яку щелепу треба виготовити ретейнер в коментарях!</div>}

          { newOrder &&     
          <div className="createOrderLayout__radioBox">
            <div className={`createOrderLayout__name ${errors.order_type ? "error" : ""}`}>Вид замовлення:</div>
            <RadioGroup row name="order_type" style={{ justifyContent: "space-evenly" }}>
              {orderType.map(({ id, value, label }) => (
                <FormControlLabel
                  key={id}
                  inputRef={register}
                  labelPlacement="start"
                  value={value}
                  control={<Radio />}
                  label={label}
                />
              ))}
            </RadioGroup>
          </div> }
          
          { newOrder &&
          <div className="createOrderLayout__checkboxes">
            <div className="createOrderLayout__name">Потрібно виправити:</div>
            <FormGroup name="problems_to_fix" style={{ alignItems: "flex-start" }}>
              {problemsToFix.map(({ id, value, label, checked }) => (
                <FormControlLabel
                  key={id}
                  value={value}
                  inputRef={register}
                  control={<Checkbox checked={checked} onChange={() => problemsToFixHandler(id)} name="problem" />}
                  label={label}
                />
              ))}
            </FormGroup>
            <p style={{ margin: "20px 0" }}>
          Класифікація аномалій прикусу по системі TranspaDent, візуалізації патологій, а також списки з вихідними
             даними, необхідними для планування ортодонтичного лікування елайнерами, знаходяться на сторінці:{" "}
            <a href="https://transpadent.org/classification-of-anomalies/" target="_blank" rel="noopener noreferrer">
              https://transpadent.org/classification-of-anomalies/
            </a>
          </p>
          </div> 
          
          }



          <div className="createOrderLayout__input column">
            <div className={`createOrderLayout__name ${errors.doctors_comment ? "error" : ""}`}>Коментарі лікаря:</div>
            <textarea name={"doctors_comment"} ref={register} />
          </div>

          <div className="createOrderLayout__radioBox">
            <div className={`createOrderLayout__name ${errors.jaw_project_material_type ? "error" : ""}`}>
            Для створення проекту будуть надані:
            </div>
            <RadioGroup row name="jaw_project_material_type" style={{ justifyContent: "space-evenly" }}>
              {jawProjectMaterialType.map(({ id, value, label }) => (
                <FormControlLabel
                  key={id}
                  inputRef={register}
                  labelPlacement="start"
                  value={value}
                  control={<Radio />}
                  label={label}
                />
              ))}
            </RadioGroup>
          </div>

          {watch("jaw_project_material_type") === "IMPRINT" && (
            <p style={{ margin: "20px 0" }}>
              Відбитки мають бути простерилізовані. Перед відправкою їх необхідно запакувати в герметичний пакет. До
               відбитків необхідно додати ідентифікацію листа з прізвищем лікаря та пацієнта. Дані для надсилання Вам
               надасть представник компанії.
            </p>
          )}
          {watch("jaw_project_material_type") === "SCAN_IMAGE" && (
            <>
              <div className="createOrderLayout__files">
                <label
                  className={`createOrderLayout__label${upperJaw.uploading ? " loading" : ""}${
                    upperJaw.uploaded ? " uploaded" : ""
                  }`}
                >
                  {upperJaw.uploaded ? (
                    <CheckCircleOutline className="createOrderLayout__upload-icon" />
                  ) : (
                    <Backup className="createOrderLayout__upload-icon" />
                  )}

                  <span>{upperJaw.uploaded ? upperJaw.titleUploaded : upperJaw.title}</span>
                  {upperJaw.uploading && (
                    <span className="createOrderLayout__fileLoader">
                      <CircularProgress color={"secondary"} />
                    </span>
                  )}
                  {!upperJaw.uploaded && <input type="file" onChange={(e) => uploadStl(e, upperJaw.fileType)} />}
                </label>

                <label
                  className={`createOrderLayout__label${lowerJaw.uploading ? " loading" : ""}${
                    lowerJaw.uploaded ? " uploaded" : ""
                  }`}
                >
                  {lowerJaw.uploaded ? (
                    <CheckCircleOutline className="createOrderLayout__upload-icon" />
                  ) : (
                    <Backup className="createOrderLayout__upload-icon" />
                  )}

                  <span>{lowerJaw.uploaded ? lowerJaw.titleUploaded : lowerJaw.title}</span>
                  {lowerJaw.uploading && (
                    <span className="createOrderLayout__fileLoader">
                      <CircularProgress color={"secondary"} />
                    </span>
                  )}
                  {!lowerJaw.uploaded && <input type="file" onChange={(e) => uploadStl(e, lowerJaw.fileType)} />}
                </label>

                <label
                  className={`createOrderLayout__label${bothJaws.uploading ? " loading" : ""}${
                    bothJaws.uploaded ? " uploaded" : ""
                  }`}
                >
                  {bothJaws.uploaded ? (
                    <CheckCircleOutline className="createOrderLayout__upload-icon" />
                  ) : (
                    <Backup className="createOrderLayout__upload-icon" />
                  )}

                  <span>{bothJaws.uploaded ? bothJaws.titleUploaded : bothJaws.title}</span>
                  {bothJaws.uploading && (
                    <span className="createOrderLayout__fileLoader">
                      <CircularProgress color={"secondary"} />
                    </span>
                  )}
                  {!bothJaws.uploaded && <input type="file" onChange={(e) => uploadStl(e, bothJaws.fileType)} />}
                </label>
              </div>
              <p className="createOrderLayout__upload-help">
              Якщо Ви не готові надати дані зараз, це можна зробити пізніше за електронною поштою або
                 за допомогою ресурсу <a href="https://colleagial.com/">colleagial.com</a>. Деталі у представника.
              </p>
            </>
          )}

          {watch("jaw_project_material_type") ? (
            <>
              <label
                className="createOrderLayout__label createOrderLayout__label_pics"
                style={loadingOtherImages ? { opacity: 0.5, pointerEvents: "none" } : null}
              >
                <AddBox />
                <h4>Додати допоміжні зображення (фото пацієнта, ТРГ, ОПТГ тощо.)</h4>
                <input type="file" multiple onChange={uploadOtherImages} />
              </label>
              <div className={`createOrderLayout__other-images${loadingOtherImages ? " loading" : ""}`}>
                {loadingOtherImages && (
                  <div className="createOrderLayout__other-images-loader">
                    <CircularProgress color="secondary" />
                  </div>
                )}
                {images.map(({ id, image }) => (
                  <img src={image} alt="" key={id} />
                ))}
              </div>
            </>
          ) : null}

          <h4>
          Увага! Після збереження цієї форми зв'яжіться з дилером або менеджером компанії для завершення процедури
             створення замовлення.
          </h4>

          <CustomButton
            type="submit"
            color="primary"
            fullWidth
            variant="contained"
            disabled={upperJaw.uploading || lowerJaw.uploading || bothJaws.uploading || loadingOtherImages}
          >
            Створити замовлення
          </CustomButton>
        </form>
      </div>
    </div>
  );
};

export default CreateOrderLayout;
